import { Controller } from '@hotwired/stimulus'
import axios from 'axios'
import '@dmuy/toast/dist/mdtoast.css'
import mdtoast from '@dmuy/toast'


export default class extends Controller {
  static targets = [
    'icon'
  ]

  static values = {
    organizationId: String
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('location sync controller connected.')
  }

  disconnect() {
  }

  sync(evt) {
    evt.preventDefault()
    this.iconTarget.classList.add('fa-spin')

    axios.post(`/ajax/organizations/${this.organizationIdValue}/sync_locations`)
      .then((response) => {
        mdtoast.info(response.data.message, { duration: 10000 })
      }).catch((error) => {
        mdtoast.error(error.response?.data?.message || error.message, { duration: 10000 })
      }).finally(() => {
        this.iconTarget.classList.remove('fa-spin')
      })
  }
}
